import React, { useState, useEffect, useContext } from 'react'
import styled from 'styled-components'
// import TreeSupport from '../Tree/Company/TreeSkill'
import { getCookie } from 'helper/cookie'
import iconInitialState from '../../../icons/createproject/supportneed.svg'
import { PlusOutlined, RedoOutlined, SearchOutlined } from '@ant-design/icons'
import DeleteProjectgroup from 'common/Management/delete'
import { toUpper } from 'lodash'
import {
  // getTree,
  getTable,
  getTableV2,
  // getResultCompany,
  postData,
  postDataV2,
  updateData,
  updateDataV2,
} from 'api/Admin/skill'
import {
  Drawer,
  Form,
  Button,
  Col,
  Row,
  Input,
  // Select,
  Alert,
  Space,
  Table,
  Modal,
  Switch,
} from 'antd'
import lang from 'lang/en'
//checkrole
import { CounterContext } from 'redux/Golbalvalues'
const ProfessionalContainer = styled.div`
  padding: 32px;
`
const initialState = {
  data: [],
  pagination: {
    pageSize: 10, //จำนวนข้อมูลในหน้านั้น
    total: 0, //ข้อมูลทั้งหมด
    current: 1,
    showQuickJumper: 1,
    // showSizeChanger: true,
    // showTotal: (total, range) => showToalPagination(total, range),
  },
}
let fastcompanyID = 0
let text_title_drawer = ''
let eventdrawer = false
let case_api_call = ''
let item_Id = 0
const showToalPagination = (total, range) => {
  return <p className="small-show-total">{`${range[0]}-${range[1]} of ${total}`}</p>
}
const TextTitleBold = styled.h2`
  font-family: 'IBMPlexSansThaiBold';
`
const Professional = () => {
  const language = getCookie('lang')
  const word = lang[language]
  const token = getCookie('access_token_admin')
  // const [dataTree, setDataTree] = useState(initialState.data)
  const [dataTable, setDataTable] = useState(initialState.data)
  // const [transfromData, setTransfromdata] = useState(initialState.data)
  // const [resultscompany, setResultscompany] = useState(initialState.data)
  const [pagination, setPagination] = useState(initialState.pagination)
  const [datagodelete, setDatagodelete] = useState(initialState.data)
  const [animation, setAnimation] = useState(false)
  // const [firstate, setFirststate] = useState(true)
  const [visibleDelete, setVisibleDelete] = useState(false)
  const [drawer, setDrawer] = useState(false)
  const [errormessage, setErrormessage] = useState(true)
  // const [searchText, setSearchText] = useState('')
  const [searchedColumn, setSearchedColumn] = useState('')
  const [form1] = Form.useForm()
  const [wordERR, setWordERR] = useState('')

  const [switchValue, setSwitchValue] = useState(true)

  //checkrole
  const { adminPermission } = useContext(CounterContext)
  //check permission
  const [disablePage, setDisablePage] = useState(false)

  const [permissionPage, setPermissionPage] = useState({
    create: false,
    read: false,
    update: false,
    delete: false,
  })

  const roleUser = getCookie('roleUser')
  useEffect(() => {
    if (roleUser == 1) {
      setPermissionPage((prevState) => ({
        ...prevState,
        create: true,
        read: true,
        update: true,
        delete: true,
      }))
    } else {
      adminPermission.map((item) => {
        if (item.menu_id == 16) {
          setPermissionPage((prevState) => ({
            ...prevState,
            create: item.create == 'Y' ? true : false,
            read: item.read == 'Y' ? true : false,
            update: item.update == 'Y' ? true : false,
            delete: item.delete == 'Y' ? true : false,
          }))
        }
      })
    }
  }, [adminPermission])

  // const fetchDataTree = async () => {
  //   await getTree({
  //     token: token,
  //     company_id: 1,
  //     level: 0,
  //     level_id: 0,
  //     language: language,
  //   })
  //     .then(async (response) => {
  //       const { status, data, error } = response
  //       if (error) {
  //         await setDataTree([])

  //         return true
  //       }
  //       if (status === 200) {
  //         if (firstate === true) {
  //           fastcompanyID = data[0].id
  //           fetchDataTable()
  //         }

  //         await setDataTree(data)
  //       } else {
  //         await setDataTree([])
  //         return true
  //       }
  //     })
  //     .catch((error) => {
  //       console.error(error)
  //     })
  // }
  // const fetchResultsCompany = async () => {
  //   await getResultCompany({
  //     token: token,
  //   })
  //     .then(async (response) => {
  //       const { status, data, error } = response
  //       if (error) {
  //         await setResultscompany([])

  //         return true
  //       }
  //       if (status === 200) {
  //         await setResultscompany(data)
  //       } else {
  //         await setResultscompany([])
  //         return true
  //       }
  //     })
  //     .catch((error) => {
  //       console.error(error)
  //     })
  // }
  // const fetchDataTable = async () => {
  //   await getTable({
  //     token: token,
  //     // company_id: fastcompanyID,
  //   })
  //     .then(async (response) => {
  //       const { status, data, error } = response

  //       if (error) {
  //         setDataTable([])
  //         return true
  //       }
  //       if (status === 200) {
  //         if (data.length <= 10) {
  //           setPagination(false)
  //         } else {
  //           setPagination(initialState.pagination)
  //         }
  //         setAnimation(true)
  //         setDataTable(data)
  //         // setFirststate(false)
  //       } else {
  //         setDataTable([])
  //         setAnimation(true)
  //         return true
  //       }
  //     })
  //     .catch((error) => {
  //       setDataTable([])

  //       console.error(error)
  //     })
  // }

  const fetchDataTable = async () => {
    await getTableV2({
      token: token,
      // company_id: fastcompanyID,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          setDataTable([])
          return true
        }
        if (status === 200) {
          if (data.length <= 10) {
            setPagination(false)
          } else {
            setPagination(initialState.pagination)
          }
          setAnimation(true)
          setDataTable(data.result)
          // setFirststate(false)
        } else {
          setDataTable([])
          setAnimation(true)
          return true
        }
      })
      .catch((error) => {
        setDataTable([])

        console.error(error)
      })
  }

  // useEffect(() => {
  //   if (token) {
  //     fetchDataTree()
  //     fetchResultsCompany()
  //   }
  // }, [token])
  useEffect(() => {
    if (token) {
      setAnimation(false)
      // fastcompanyID = transfromData.id
      fetchDataTable()
    }
  }, [
    token,
    // transfromData
  ])

  function onChange(pagination2, filters, sorter, extra) {
    if (pagination != false) {
      setPagination((prevState) => {
        return {
          ...prevState,
          pageSize: pagination2.pageSize,
          current: pagination2.current,
        }
      })
    }
  }
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm()
    // setSearchText(selectedKeys[0])
    setSearchedColumn(dataIndex)
  }
  const handleReset = (clearFilters) => {
    clearFilters()
    // setSearchText('')
  }
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            className="mini-search-btn-admin"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          >
            <SearchOutlined className="icon" />
            {word['Search']}
          </Button>
          <Button
            type="primary"
            className="mini-search-btn-admin-reset"
            onClick={() => handleReset(clearFilters)}
          >
            {word['Reset']}
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',

    render: (text) => (searchedColumn === dataIndex ? text : text),
  })
  const dataSourceTable = dataTable?.map((item) => ({
    // company_code: item.company_code,
    skill_code: item.code,
    local_skill_name: item.title,
    english_skill_name: item.title_en,
    data: item, // แถม data ทั้งหมดไปเพื่อใช้บางอย่าง
    status: item.status,
  }))
  const columns_group = [
    // {
    //   title: <h5> {word['Company']}</h5>,
    //   dataIndex: 'company_code',
    // },
    {
      title: <h5>{word['Skill_code']}</h5>,
      dataIndex: 'skill_code',
      sorter: (a, b) => a.skill_code.localeCompare(b.skill_code),
      ...getColumnSearchProps('skill_code'),
    },
    {
      title: <h5>{word['Local_Skill_name']}</h5>,
      dataIndex: 'local_skill_name',
      sorter: (a, b) => a.local_skill_name.localeCompare(b.local_skill_name),
      ellipsis: true,
      ...getColumnSearchProps('local_skill_name'),
    },
    {
      title: <h5>{word['English_Skill_name']}</h5>,
      dataIndex: 'english_skill_name',
      sorter: (a, b) => a.english_skill_name.localeCompare(b.english_skill_name),
      ellipsis: true,
      ...getColumnSearchProps('english_skill_name'),
    },
    {
      title: <h5>Status</h5>,
      dataIndex: 'status',
      sorter: (a, b) => a.status.localeCompare(b.status),
      ellipsis: true,
      width: 180,
      ...getColumnSearchProps('status'),
    },
  ]
  const renderDrawer = (dataIncome, fade) => {
    setDrawer(true)
    case_api_call = fade
    setErrormessage(true)
    if (fade === 'add') {
      setSwitchValue(true)
      eventdrawer = true
      text_title_drawer = 'Add Professional Skill'
      form1.setFieldsValue({
        // form_company_code: fastcompanyID,
        form_skill_code: null,
        form_local_skill_name: null,
        form_english_skill_name: null,
        status: true,
      })
    } else if (fade === 'edit') {
      eventdrawer = false
      text_title_drawer = 'Edit Professional Skill'
      item_Id = dataIncome.data.id
      setDatagodelete(dataIncome.data)
      permissionPage.update ? setDisablePage(false) : setDisablePage(true)
      const isActive = dataIncome.data.status
      setSwitchValue(isActive === 'Active')
      form1.setFieldsValue({
        // form_company_code: dataIncome.data.company_id,
        form_skill_code: dataIncome.data.code,
        form_local_skill_name: dataIncome.data.title,
        form_english_skill_name: dataIncome.data.title_en,
        status: switchValue,
      })
    }
  }
  // const onFinish = (value) => {
  //   if (case_api_call === 'add') {
  //     const newDataMaster = {
  //       company_id: value.form_company_code,
  //       code: value.form_skill_code,
  //       title: value.form_local_skill_name,
  //       title_en: value.form_english_skill_name,
  //       // status: value.form_status ? 'Active' : 'Inactive',
  //       status: 'Inactive',
  //     }
  //     try {
  //       postData({
  //         params: newDataMaster,
  //         token: token,
  //       }).then((res) => {
  //         if (res.status === 200) {
  //           setDrawer(false)
  //           fetchDataTable()
  //           setErrormessage(true)
  //         } else {
  //           if (res.data.errorCode === '2008') {
  //             setWordERR(word['err_professionskills_code'])
  //           } else {
  //             setWordERR('error')
  //           }
  //           setErrormessage(false)
  //         }
  //       })
  //     } catch (error) {
  //       console.log(error)
  //     }
  //   } else if (case_api_call === 'edit') {
  //     const newDataMaster = {
  //       id: item_Id,
  //       company_id: value.form_company_code,
  //       code: value.form_skill_code,
  //       title: value.form_local_skill_name,
  //       title_en: value.form_english_skill_name,
  //       // status: value.form_status ? 'Active' : 'Inactive',
  //       status: 'Inactive',
  //     }
  //     try {
  //       updateData({
  //         params: newDataMaster,
  //         token: token,
  //       }).then((res) => {
  //         if (res.status === 200) {
  //           setDrawer(false)
  //           fetchDataTable()
  //           setErrormessage(true)
  //         } else {
  //           if (res.data.errorCode === '2018') {
  //             setWordERR(word['err_professionskills_itemused'])
  //           } else if (res.data.errorCode === '2008') {
  //             setWordERR(word['err_professionskills_code'])
  //           } else {
  //             setWordERR('error')
  //           }
  //           setErrormessage(false)
  //         }
  //       })
  //     } catch (error) {
  //       console.log(error)
  //     }
  //   }
  // }

  const onFinish = (value) => {
    if (case_api_call === 'add') {
      const newDataMaster = {
        company_id: value.form_company_code,
        code: value.form_skill_code,
        title: value.form_local_skill_name,
        title_en: value.form_english_skill_name,
        status: value.status ? 'Active' : 'Inactive',
        // status: 'Inactive',
      }
      try {
        postDataV2({
          params: newDataMaster,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            setDrawer(false)
            fetchDataTable()
            setErrormessage(true)
            setSwitchValue(true)
          } else {
            if (res.data.errorCode === '2008') {
              setWordERR(word['err_professionskills_code'])
            } else {
              setWordERR('error')
            }
            setErrormessage(false)
          }
        })
      } catch (error) {
        console.log(error)
      }
    } else if (case_api_call === 'edit') {
      const newDataMaster = {
        id: item_Id,
        company_id: value.form_company_code,
        code: value.form_skill_code,
        title: value.form_local_skill_name,
        title_en: value.form_english_skill_name,
        status: value.status ? 'Active' : 'Inactive',
        // status: 'Inactive',
      }
      try {
        updateDataV2({
          params: newDataMaster,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            setDrawer(false)
            fetchDataTable()
            setErrormessage(true)
            setSwitchValue(true)
          } else {
            if (res.data.errorCode === '2018') {
              setWordERR(word['err_professionskills_itemused'])
            } else if (res.data.errorCode === '2008') {
              setWordERR(word['err_professionskills_code'])
            } else {
              setWordERR('error')
            }
            setErrormessage(false)
          }
        })
      } catch (error) {
        console.log(error)
      }
    }
  }

  const onClickDelete = () => {
    setVisibleDelete(true)
  }
  const RenderStateTable = () => {
    if (dataTable.length > 0) {
      return (
        <div className={animation ? 'animation-container' : 'active-animation-container'}>
          <div className="layout-button-add-normal-state">
            <TextTitleBold>{word['List_Professional']}</TextTitleBold>
            <div>
              <Button
                hidden={permissionPage.create ? false : true}
                type="primary"
                className="BTN_Next"
                onClick={() => renderDrawer([], 'add')}
              >
                <PlusOutlined className="Icon-color" />
                {word['Add_Professional_Skill']}
              </Button>
              <Button
                style={{ marginLeft: 8 }}
                type="primary"
                className="btn_Secondary2"
                onClick={() => window.location.reload()}
              >
                <RedoOutlined className="Icon-color" />
                {word['Reset']}
              </Button>
            </div>
          </div>
          <Table
            onRow={(record) => {
              return {
                onClick: () => renderDrawer(record, 'edit'), // click row
              }
            }}
            columns={columns_group}
            dataSource={dataSourceTable}
            onChange={onChange}
            showSorterTooltip={false}
            pagination={pagination}
          />
        </div>
      )
    } else {
      return (
        <div
          className={
            animation ? 'initialstate-container' : 'active-initialstate-container'
          }
        >
          <img className="initialstate-icon" src={iconInitialState}></img>
          <h2 className="no-breadcrumb">{word['Please_add_professional_skills']}</h2>
          <Button
            hidden={permissionPage.create ? false : true}
            type="primary"
            className="btn_Secondary2"
            onClick={() => renderDrawer([], 'add')}
          >
            <PlusOutlined className="Icon-color" />
            {word['Add_Professional_Skill']}
          </Button>
        </div>
      )
    }
  }

  return (
    <ProfessionalContainer>
      {RenderStateTable()}
      <Modal
        maskClosable={false}
        destroyOnClose
        title={<TextTitleBold>{text_title_drawer}</TextTitleBold>}
        width={'634px'}
        onCancel={() => setDrawer(false)}
        visible={drawer}
        className="fix-modal"
        placement="right"
        footer={
          <div
            style={{
              textAlign: 'right',
            }}
          >
            <Button
              className="BTN_Delete_CPF_RED"
              style={{ marginRight: 8 }}
              hidden={permissionPage.delete ? eventdrawer : true}
              onClick={() => onClickDelete()}
            >
              {word['Delete']}
            </Button>
            <Button
              hidden={permissionPage.update ? false : true}
              className="BTN_Next"
              onClick={form1.submit}
              type="primary"
            >
              {word['Save']}
            </Button>
          </div>
        }
      >
        <Form form={form1} layout="vertical" onFinish={onFinish}>
          <fieldset disabled={disablePage} className="disable-page">
            <Row gutter={16}>
              {/* <Col span={12}>
                  <Form.Item
                    name="form_company_code"
                    label={<h4>{word['Company_Code']}</h4>}
                    rules={[{ required: true, message: 'please select company.' }]}
                    className="disable-page"
                  >
                    <Select
                      showSearch
                      id="select"
                      size="large"
                      disabled={disablePage}
                      placeholder="Company Code"
                      allowClear
                      optionFilterProp="children"
                    >
                      {resultscompany.map((item) => (
                        <Option key={item.id} value={item.id} data={item}>
                          {item.code} {item.name_en}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col> */}
              <Col span={24}>
                <Form.Item
                  name="form_skill_code"
                  label={<h4>{word['Skill_Code']}</h4>}
                  rules={[
                    {
                      whitespace: true,
                    },
                  ]}
                  onChange={(e) =>
                    form1.setFieldsValue({
                      form_skill_code: e.target.value.replace(/\s/g, ''),
                    })
                  }
                  onKeyUp={(e) =>
                    form1.setFieldsValue({
                      form_skill_code: toUpper(e.target.value),
                    })
                  }
                  maxLength={10}
                >
                  <Input size="large" placeholder="Skill Code" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  name="form_local_skill_name"
                  label={<h4>{word['Local_Skill_Name']}</h4>}
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: 'Please enter local skill name',
                    },
                  ]}
                >
                  <Input size="large" placeholder="Local Skill Name" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  name="form_english_skill_name"
                  label={<h4>{word['English_Skill_Name']}</h4>}
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: 'Please enter english skill name.',
                    },
                  ]}
                >
                  <Input size="large" placeholder="English Skill Name" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item name="status">
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: '8px' }}>Status Active:</span>
                    <Switch
                      checked={switchValue}
                      onChange={(checked) => {
                        form1.setFieldsValue({ status: checked })
                        setSwitchValue(checked)
                      }}
                    ></Switch>
                  </div>
                </Form.Item>
              </Col>
            </Row>
          </fieldset>
        </Form>
        <DeleteProjectgroup
          visibleDelete={visibleDelete}
          setVisibleDelete={setVisibleDelete}
          state="professional_skill"
          data={datagodelete}
          renderData={fetchDataTable}
          setVisibleDrawer={setDrawer}
        />
      </Modal>
    </ProfessionalContainer>
  )
}
export default Professional
